<template>
  <v-row
    v-if="templateConfig.theme !== 'Operator-Template'"
    class="mx-0 mt-0 mb-4 noAnimation"
  >
    <v-col>
      <v-form
        v-model="isValidForm"
        ref="initSubForm"
        @submit="isValidForm && subscribe()"
        onSubmit="return false;"
      >
        <Alert
          :message="error"
          type="error"
          v-if="showError"
          @toggleAlert="showError = !showError"
        />
        <v-row>
          <v-col class="py-0">
            <v-text-field
              v-model="SubscribeFlowDetails.checkoutHeaderEnrichmentInfo.msisdn"
              disabled
              :label="merchantConfig.texts.mobileNumberTextFieldLabel"
              :loading="!dataFetched"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              block
              :disabled="!isButtonActive"
              :loading="loading"
              :rounded="templateConfig.isButtonRounded"
              class="mainButton"
              id="paymentBtn"
              v-prevent-multiple-clicks:click="subscribe"
            >
              <span v-html="initBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
        <SecondaryDisclaimer
          v-if="
            SubscribeFlowDetails.merchantOperatorDisclaimer.vatDisclaimer !=
              'NoDisclaimer' ||
            initSecondaryDisclaimerText ||
            freeStartDisclaimerText
          "
        >
          <div class="secondryDisc">
            <VatDisclaimerMsg
              :message="
                SubscribeFlowDetails.merchantOperatorDisclaimer.vatDisclaimer
              "
            />
            <div v-html="freeStartDisclaimerText"></div>
            <div v-html="initSecondaryDisclaimerText"></div>
          </div>
        </SecondaryDisclaimer>
      </v-form>
    </v-col>
  </v-row>

  <!-- Embedded template-->
  <v-row
    v-else-if="templateConfig.theme === 'Operator-Template'"
    class="mx-0 mt-0 mb-4"
  >
    <v-col>
      <v-form
        v-model="isValidForm"
        ref="initSubForm"
        @submit="isValidForm && subscribe()"
        onSubmit="return false;"
      >
        <v-row class="justify-center">
          <v-col cols="12" sm="7" md="5" lg="4" xl="3">
            <Alert
              :message="error"
              type="error"
              v-if="showError"
              @toggleAlert="showError = !showError"
            />
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="12" sm="4" md="3" class="py-0">
            <v-text-field
              v-model="SubscribeFlowDetails.checkoutHeaderEnrichmentInfo.msisdn"
              disabled
              :loading="!dataFetched"
              :label="merchantConfig.texts.mobileNumberTextFieldLabel"
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="termsCheckbox"
              :label="this.$translate('TermsCheckbox_MSG')"
              color="primary"
              :rules="termsAgreementRules"
              class="checkboxAlignment termsCheckbox"
              off-icon=""
              on-icon=""
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="4" md="3">
            <v-btn
              block
              :disabled="!isButtonActive"
              :loading="loading"
              :rounded="templateConfig.isButtonRounded"
              class="mainButton"
              id="paymentBtn"
              v-prevent-multiple-clicks:click="subscribe"
            >
              <span v-html="initBtnText" v-if="!loading"></span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
//1.General imports.
import { mapState, mapMutations } from 'vuex';
import { startSubscribeMixin } from './startSubscribeMixin.js';
import subscriptionType from 'constants/subscriptionType';

//2.shared comp. imports.
import { fraudToolMixin } from '../../Shared/Mixins/fraudToolMixin';
import VatDisclaimerMsg from '../../Shared/components/VATDisclaimerMsg.vue';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';
import Alert from '../../Shared/components/Alert.vue';
import requiredRules from '../../Shared/Rules/requiredRules.js';

export default {
  mixins: [startSubscribeMixin, fraudToolMixin],
  data() {
    return {
      dataFetched: false,
      showError: false,
      error: '',
      subscriptionContractId: null,
      loading: false,
      isValidForm: true,
      termsCheckbox: false,
      termsAgreementRules: requiredRules(),
      sessionId: new Date().getTime().toString(),
    };
  },
  components: {
    VatDisclaimerMsg,
    SecondaryDisclaimer,
    Alert,
  },
  computed: {
    ...mapState(['templateConfig', 'SubscribeFlowDetails', 'merchantConfig']),

    isButtonActive() {
      return this.isValidForm && this.dataFetched;
    },
    initBtnText() {
      //Needs $replacePlaceholders plugin function for [productName] placeholders.
      return this.$replacePlaceholders(this.merchantConfig.texts.initBtn, {
        productName:
          this.SubscribeFlowDetails.subscriptionProductDetails
            .initialProductName,
      });
    },
    initSecondaryDisclaimerText() {
      return this.merchantConfig.texts.initSecondaryDisclaimer;
    },
    freeStartDisclaimerText() {
      //Needs $replacePlaceholders plugin function for [productPrice, currency, frequency, trialPeriod] placeholders.
      if (
        this.SubscribeFlowDetails.subscriptionProductDetails.freeStartPeriod
      ) {
        return this.$replacePlaceholders(
          this.merchantConfig.texts.freeStartDisclaimer,
          {
            price: this.SubscribeFlowDetails.merchantOperatorDisclaimer.price,
            currency:
              this.SubscribeFlowDetails.merchantOperatorDisclaimer.currency,
            frequency:
              this.SubscribeFlowDetails.subscriptionProductDetails.frequency,
            trialPeriod:
              this.SubscribeFlowDetails.subscriptionProductDetails
                .freeTrialDays,
          }
        );
      } else {
        return '';
      }
    },
  },
  methods: {
    ...mapMutations(['setSubscribeFlowDetails']),
    checkExisistingSubscription() {
      if (
        this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo
          .activeSubscriptionId &&
        this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo
          .activeSubscriptionId != ''
      ) {
        this.subscriptionContractId =
          this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo.activeSubscriptionId;
        this.error = `${this.$translate(
          'ALREADYSUBSCRIBEDERR'
        )} <span dir="ltr">${
          this.SubscribeFlowDetails.subscriptionProductDetails
            .initialProductName
        } </span>`;
        this.moveToFailurePage(this.error, '51');
      }
    },
    async subscribe() {
      if (!this.$refs.initSubForm.validate()) return;
      this.loading = true;

      //validateFraudTool "fraudToolMixin".
      const validateFraudToolResult = await this.validateFraudTool(
        {
          operatorCode:
            this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo.operatorCode,
          country: this.SubscribeFlowDetails.twoLetterCountryCode,
          msisdn: this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo.msisdn,
          ...this.SubscribeFlowDetails.merchantAdditionalParams,
        },
        this.sessionId
      );

      if (validateFraudToolResult.isUserClear) {
        this.setSubscribeFlowDetails({
          sessionToken: validateFraudToolResult.sessionToken,
        });
      } else {
        this.moveToFailurePage(
          this.$translate('FRAUDTOOLERRORMSG'), //optional
          102, // Note : 102 "operationStatusCode" === Fraud in the back-end.
          true // reloadInFailure
        );
        return;
      }

      if (
        this.SubscribeFlowDetails.subscriptionProductDetails.subscriptionType ==
        subscriptionType.FREE_START_PERIOD //FREE_START_PERIOD ,  PARKING_PERIOD
      ) {
        // check if already took the free period
        let userShouldGetFreeStartPeriod = await this.$http.get(
          `/sub/UserShouldGetFreeStartPeriod`
        );

        this.setSubscribeFlowDetails({
          userShouldGetFreeStartPeriod: userShouldGetFreeStartPeriod.data,
        });

        if (!userShouldGetFreeStartPeriod.data) {
          // go to confirm-after-trial-period screen
          this.setSubscribeFlowDetails({
            step: 1,
            component: 'HEConfirmTrial',
          });
          this.loading = false;
          this.showError = false;
        } else {
          this.startSubscribe();
        }
      } else {
        this.startSubscribe();
      }
    },
  },
  async created() {
    await this.includeFraudPackage();
    this.checkExisistingSubscription();

    //injectFraudTool from "fraudToolMixin"
    await this.injectFraudTool(
      this.SubscribeFlowDetails.fraudToolName,
      this.SubscribeFlowDetails.fraudToolParameters,
        this.sessionId,
        this.SubscribeFlowDetails.checkoutHeaderEnrichmentInfo.operatorCode,
            this.SubscribeFlowDetails.twoLetterCountryCode
    );
    this.dataFetched = true;
  },

  deactivated() {
    this.loading = false;
  },
};
</script>
